import { useScrollToTop } from "@/hooks/useScrollToTop"
import { isInApp } from "@/utils/in-app-checker"
import { Outlet } from "react-router-dom"
import Footer from "../Footer/Footer"
import Header from "../Header/Header"

const Layout = () => {
  useScrollToTop()

  if (isInApp()) {
    return (
      <div>
        <Outlet />
      </div>
    )
  }

  return (
    <>
      <Header />
      <div>
        <Outlet />
      </div>
      <Footer />
    </>
  )
}

export default Layout
